<div class="container-fluid">
  <div class="pt-4">
    <div class="d-flex justify-content-between align-items-center">
      @if (user) {
        <h4 class="fw-bold lh-sm">{{ 'congratulations' | transloco }}, {{ user.lastName }} {{ user.firstName }}!</h4>
      }
      <button (click)="changePasswordModal()" type="button" class="btn btn-outline-primary">
        {{ 'change_password' | transloco }}
      </button>
    </div>
  </div>
  <app-dashboard [listMenuItems]="clinicHomeIconsList"></app-dashboard>
  <app-change-password-modal
    [whoSignIn]="UserTypeEnum.staff"
    (formData)="changePassword($event)"
    [isLoading]="isLoading"
  ></app-change-password-modal>
</div>
